import React, { useState } from 'react'
import init from '../firebase'
import { useUserAuth } from '../context/UserAuthContext'
import { updateEmail } from 'firebase/auth'
import { updateDoc } from 'firebase/firestore'

const UpdateEmail = () => {
    const {user} = useUserAuth()
    const merchant_id = user.uid;
    const [email, setEmail] = useState('')

    const btnHandler = async (e) =>{
        e.preventDefault()
        try{
            await updateEmail(init.auth.currentUser, email)
            alert('Email updated')
            console.log('email auth changed...')
            await updateDoc(doc(init.db, "merchants", merchant_id), {
                vendorProfile:{
                    email
                }
            });
            console.log('basic detail email changed...')
            setEmail('')
        } catch(err){
            console.log(err)
        }
    }
    return (
        <div className='page-wrapper'>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className="card-header text-white bg-primary">
                                Update Email 
                            </div>
                            <div className='card-body'>
                            <form onSubmit={btnHandler}>
                                <div className="form-group">
                                <input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder='Enter Email' className='form-control'/>
                                </div>
                                <div className="form-group">
                                    <input type="submit" value="Update Email" className='btn btn-primary' disabled={!email} />
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UpdateEmail